import { all, put, takeEvery, select } from 'redux-saga/effects'

import { Game, Api, Auth } from '../../Core'

import MiningChangePhasePopup from './MiningChangePhasePopup'
import MiningScreensContainer from './MiningScreensContainer'
import MiningSelectScreen from './MiningSelectScreen'

import * as actions from './mining.actions'

import * as quizzesSelectors from '../Quizzes/quizzes.selectors'
import * as quizzesActions from '../Quizzes/quizzes.actions'

export function* loadComponents() {
  const components = {
    MiningChangePhasePopup,
    MiningSelectScreen,
    MiningScreensContainer,
  }

  yield put(Game.actions.registerComponents(components))
}

export function* init() {
  yield loadComponents()
}

export function* changeMiningScreen(action) {
  const currentQuestion = yield select(quizzesSelectors.getVoteQuestion)

  switch (action.data) {
    case 'answer_question':
      yield put(quizzesActions.getQuestion())
      break
    case 'vote_question':
      !currentQuestion ? yield put(quizzesActions.getDisputeQuestion()) : null
      break
  }
}
export function* getCountDisputesSagas() {
  const userInfo = yield select(Auth.selectors.getUserInfo)

  const [playerId, groupId] = [userInfo.licenseId, userInfo.licenseData.groupId]

  try {
    const data = yield Api.get(
      `/questions/countDisputes?playerId=${playerId}&groupId=${groupId}`,
      {}
    )
    yield put(actions.getCountDisputesSuccess(data))
  } catch (e) {
    yield put(actions.getCountDisputesError('get_count_disputes_error'))
    console.log(e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

export function* getOwnQuestionSagas() {
  try {
    const data = yield Api.get(`/questions/list`, {})
    yield put(actions.getOwnQuestionsSuccess(data))
  } catch (e) {
    yield put(actions.getOwnQuestionsError('get_own_questions_error'))
    console.log(e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

export function* sagas() {
  yield all([
    init(),
    takeEvery(actions.CHANGE_MINING_SCREEN, changeMiningScreen),
    takeEvery(actions.GET_COUNT_DISPUTES, getCountDisputesSagas),
    takeEvery(actions.GET_OWN_QUESTIONS, getOwnQuestionSagas),
  ])
}
